import { suggest_CloseCircleFill_str } from '@zenlayer/zen-design-icons';
import { useControllableValue, useCreation } from 'ahooks';
import { Select } from 'antd';
import classnames from 'classnames';
import { last } from 'ramda';
import React, { useState } from 'react';
import { pickDomAttrs } from '../_util/utils';
import SvgIcon from '../svg-icon';
import Tooltip from '../tooltip';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const InputTag = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    label,
    width = '100%',
    type = 'outline',
    disabled = false,
    error,
    rules = [],
    onFocus,
    onBlur,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-inputTag");
  const attrs = pickDomAttrs(restProps);
  const [value = [], setValue] = useControllableValue(props);
  const [searchValue, setSearchValue] = useState('');
  const [searchError, setSearchError] = useState('');
  const [isFocus, setIsFocus] = useState(false);
  const errorMsg = error && typeof error === 'string' ? error : searchError;
  return /*#__PURE__*/_jsx("div", {
    ...attrs.data,
    ref: ref,
    className: classnames(className, baseClassName, "".concat(baseClassName, "--").concat(type), {
      ["".concat(baseClassName, "--shrink")]: value.length > 0 || isFocus,
      ["".concat(baseClassName, "--focus")]: isFocus,
      ["".concat(baseClassName, "--disabled")]: disabled,
      ["".concat(baseClassName, "--error")]: !!error || !!searchError
    }),
    style: {
      ...style,
      width
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "-inner"),
      children: [useCreation(() => /*#__PURE__*/_jsx(Tooltip, {
        open: isFocus && !!errorMsg,
        title: errorMsg,
        getPopupContainer: triggerNode => triggerNode.parentNode,
        children: /*#__PURE__*/_jsx("div", {
          className: "".concat(baseClassName, "-error-anchor")
        })
      }), [isFocus, errorMsg]), /*#__PURE__*/_jsx("div", {
        className: "".concat(baseClassName, "-label"),
        children: label
      }), /*#__PURE__*/_jsx(Select, {
        mode: "tags",
        value: value,
        variant: "borderless",
        open: false,
        disabled: disabled,
        searchValue: searchValue,
        removeIcon: /*#__PURE__*/_jsx(SvgIcon, {
          svgStr: suggest_CloseCircleFill_str,
          className: "".concat(baseClassName, "-tags-remove")
        }),
        onSearch: v => {
          setSearchValue(v);
          setSearchError('');
        },
        onFocus: () => {
          onFocus === null || onFocus === void 0 || onFocus();
          setIsFocus(true);
        },
        onBlur: () => {
          onBlur === null || onBlur === void 0 || onBlur();
          setIsFocus(false);
          setSearchError('');
        },
        onChange: v => {
          const _v = v.filter(it => !!it);
          const text = last(_v);
          if (text && rules.length) {
            let errMsg = '';
            rules.find(r => {
              var _r$validator;
              const validatorMsg = (_r$validator = r.validator) === null || _r$validator === void 0 ? void 0 : _r$validator.call(r, text, v);
              if (validatorMsg) {
                errMsg = validatorMsg;
              } else if (r.pattern && !r.pattern.test(text)) {
                errMsg = r.message || 'Input invalid';
              }
              return !!errMsg;
            });
            if (errMsg) {
              setSearchError(errMsg);
              return;
            }
          }
          setValue(_v);
          setSearchValue('');
          setSearchError('');
        },
        className: "".concat(baseClassName, "-tags")
      })]
    })
  });
});
export default InputTag;